'use client';

import { createContext } from 'react';

export const IsWithinLayoutContext = createContext(false);
